import React from 'react';
import PropTypes from 'prop-types';
import { Col } from '@saucelabs/sl-component-grid';

import Styles from './DropdownColumn.styles';

const DropdownColumn = ({ children }) => (
  <Col
    className={Styles.default}
    lg
    sm
    xs={12}
  >
    {children}
  </Col>
);

DropdownColumn.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DropdownColumn;
